/**
 * defa.views.EmptyView
 * A context-aware view for when CollectionView's got no results.
 * @version 1.2.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/emptyView.jst.html';

const EmptyView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	// add white text/no card styling for the support panel empty view.
	className: function () {
		return this.getClassName();
	},
	
	templateContext: function () {
		return {
			context: this.options.context || 'noresults',
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Sets a className for the EmptyView element based on context.
	 * @return {string}  A context-aware className.
	 */
	getClassName: function () {
		
		let ret = '';
		
		switch ( this.options.context ) {
			
			case 'supportserp' :
				ret = 'response-string';
				break;
			
			case 'notifications' :
				ret = '';
				break;
			
			default :
				ret = 'card';
				break;
		}
		
		return ret;
	},
	
} );

export default EmptyView;